export default "__VITE_ASSET__DWpd7Bz7__"